import { PublicClientApplication } from '@azure/msal-browser';
import React from 'react';

interface UIConfig {
  apiUrl: string;
  theme: string;
  toggleTheme: () => void;
  minimumBrowserVersions: Record<string, number>;
  environment?: string;
  Logo?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  footerUrl: string;
  footerName: string;
  meta: { title: string; description: string };
  msalInstance: PublicClientApplication;
}

const UIContext = React.createContext<UIConfig | null>(null);

export function UIProvider({ children, config }: { children: React.ReactNode; config: UIConfig }) {
  return <UIContext.Provider value={config}>{children}</UIContext.Provider>;
}

export function useUIConfig(): UIConfig {
  const ctx = React.useContext(UIContext);

  if (!ctx) {
    throw new Error('useUIConfig must be used within UIProvider');
  }

  return ctx;
}
